import React from 'react';

export default function Footer({ className = '' }) {
  return (
    <footer className={`app-footer ${className}`}>
      Powered by <a href="https://weiodigital.com/" target="_blank" rel="noopener noreferrer">weioDigital</a>
    </footer>
  );
}
